export default __webpack_public_path__ + "static/media/SEA_7382.eea00782.jpg";